import React, { useContext } from 'react'
import type { EmblaCarouselType } from 'embla-carousel'
import { CarouselContext } from '..'

import { DefaultPagination } from './DefaultPagination'
import { useNavigation } from '../hooks/useNavigation'
import { cn } from '@s4l/utility-css'

import styles from './styles.module.css'

export interface IPaginationProps {
  children?: (current: number, total: number) => React.ReactNode
  startIndex: number
  emblaApi?: EmblaCarouselType
}

export const Pagination = ({ children, startIndex, emblaApi }: IPaginationProps) => {
  const { variant } = useContext(CarouselContext)
  const { currentPage, numberOfPages } = useNavigation({ startIndex, emblaApi })

  return (
    <div className={cn(styles.pagination, variant && styles[variant])} data-testid="pagination">
      {children ? (
        children(currentPage, numberOfPages)
      ) : (
        <DefaultPagination current={currentPage} total={numberOfPages} />
      )}
    </div>
  )
}

Pagination.displayName = 'Carousel.Pagination'
